/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiFrameSizeMinIcon16Light } from './UiFrameSizeMinIcon16Light';
import { UiFrameSizeMinIcon16Regular } from './UiFrameSizeMinIcon16Regular';
import { UiFrameSizeMinIcon16Solid } from './UiFrameSizeMinIcon16Solid';
import { UiFrameSizeMinIcon20Light } from './UiFrameSizeMinIcon20Light';
import { UiFrameSizeMinIcon20Regular } from './UiFrameSizeMinIcon20Regular';
import { UiFrameSizeMinIcon20Solid } from './UiFrameSizeMinIcon20Solid';
import { UiFrameSizeMinIcon24Regular } from './UiFrameSizeMinIcon24Regular';
import { UiFrameSizeMinIcon24Solid } from './UiFrameSizeMinIcon24Solid';
import { UiFrameSizeMinIcon32Regular } from './UiFrameSizeMinIcon32Regular';
import { UiFrameSizeMinIcon64Regular } from './UiFrameSizeMinIcon64Regular';
var sizes = {
    16: {
        light: UiFrameSizeMinIcon16Light,
        regular: UiFrameSizeMinIcon16Regular,
        solid: UiFrameSizeMinIcon16Solid,
    },
    20: {
        light: UiFrameSizeMinIcon20Light,
        regular: UiFrameSizeMinIcon20Regular,
        solid: UiFrameSizeMinIcon20Solid,
    },
    24: {
        regular: UiFrameSizeMinIcon24Regular,
        solid: UiFrameSizeMinIcon24Solid,
    },
    32: {
        regular: UiFrameSizeMinIcon32Regular,
    },
    64: {
        regular: UiFrameSizeMinIcon64Regular,
    },
};
export var UiFrameSizeMinIcon = forwardRef('UiFrameSizeMinIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
